import React from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import * as Yup from "yup";

const EditStaff = ({
  editStaffMutate,
  editStaffLoading,
  setEditStaff,
  selectedData,
}) => {
  const formik = useFormik({
    initialValues: {
      name: selectedData?.name || "",
      mobile: selectedData?.mobile || "",
      gender: selectedData?.gender || "",
      salary: selectedData?.salary || "",
      status: selectedData?.status || "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Enter Valid number")
        .required("Mobile number is required"),
      gender: Yup.string().required("Gender is required"),
      status: Yup.number()
        .required("Select Status")
        .min(1, "Status can be active or inactive"),
    }),
    onSubmit: async (values) => {
      editStaffMutate(values);
    },
  });
  return (
    <Model width="w-11/12 max-w-lg" setOpenModel={setEditStaff}>
      <Wrapper>
        <Title>Edit Staff</Title>
        <form onSubmit={formik.handleSubmit}>
          <Wrapper>
            <InputGroup>
              <Label htmlFor="name">Name*</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  autoComplete="off"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  //onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name ? (
                  <p className="text-rose-600 text-sm ">{formik.errors.name}</p>
                ) : null}
              </FieldWrapper>
            </InputGroup>

            <CombineInputGroup className="pb-3">
              <InputGroup className="">
                <Label htmlFor="mobile">Phone*</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="mobile"
                    id="mobile"
                    autoComplete="off"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    maxLength={10}
                  />
                  {formik.touched.mobile && formik.errors.mobile ? (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.mobile}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="status">Status*</Label>
                <FieldWrapper>
                  <Select
                    name="status"
                    id="status"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    //onBlur={formik.handleBlur}
                    className="w-full pl-2"
                    style={{ height: "40px" }}
                  >
                    <MenuItem value="1">Active</MenuItem>
                    <MenuItem value="2">Inactive</MenuItem>
                  </Select>
                  {formik.touched.status && formik.errors.status ? (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.status}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>
            </CombineInputGroup>

            <CombineInputGroup className="pb-3">
              <InputGroup>
                <Label htmlFor="salary">Salary ₹</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="salary"
                    id="salary outlined-size-small"
                    autoComplete="off"
                    variant="outlined"
                    value={formik.values.salary}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (/^\d{0,10}$/.test(value)) {
                        formik.handleChange(e);
                      }
                    }} //onBlur={formik.handleBlur}
                  />
                  {formik.touched.salary && formik.errors.salary ? (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.salary}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="gender">Gender*</Label>
                <FieldWrapper>
                  <Select
                    name="gender"
                    id="gender"
                    value={formik.values.gender}
                    onChange={formik.handleChange}
                    className="w-full  pl-2"
                    style={{ height: "40px" }}
                  >
                    <MenuItem value="1">Male</MenuItem>
                    <MenuItem value="2">Female</MenuItem>
                  </Select>
                  {formik.touched.gender && formik.errors.gender ? (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.gender}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>
            </CombineInputGroup>
          </Wrapper>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={editStaffLoading}>
              {editStaffLoading ? "Submitting..." : "Submit"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </Wrapper>
    </Model>
  );
};
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;

export default EditStaff;
